exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".date-category-heading {\n  font-size: 12px;\n  line-height: 18px;\n  color: #ef426f;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 5px;\n}\n\n.date-category-heading .category {\n  margin-right: 5px;\n}\n\n.date-category-heading .date {\n  color: #ababab;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/date-category-heading/date-category-heading.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/date-category-heading/date-category-heading.css
// module chunks = 0